import React from 'react';

/**
 * A compact summary card on a conditional set-up page: a heading with an
 * optional chip, optional description lines, and an optional inline action
 * that expands the editor passed as children below the card. regionId names
 * that editor's region, which the action (or an outside toggle) controls.
 */
export default function SetupCard({ heading, chip, lines = [], actionLabel, expanded, onToggle, regionId, children }) {
    return (
        <div className="tw-flex tw-flex-col tw-gap-y-3 tw-min-w-0">
            <div className="tw-px-3.5 tw-py-2.5 tw-rounded-lg tw-border tw-border-charcoal-15 tw-bg-charcoal-10">
                <div className="tw-flex tw-items-center tw-gap-x-2.5">
                    <h3 className="tw-text-sm tw-font-normal tw-text-charcoal tw-mb-0">{heading}</h3>
                    {chip && <span className="tw-ms-auto tw-text-2xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-charcoal-50">{chip}</span>}
                </div>
                {(lines.length > 0 || actionLabel) && (
                    <div className="tw-mt-2 tw-ps-3.5 tw-border-s-2 tw-border-charcoal-15">
                        {lines.map((line) => (
                            <p key={line} className="tw-py-0.5 tw-mb-0 tw-text-0.5sm tw-text-charcoal-75">
                                {line}
                            </p>
                        ))}
                        {actionLabel && (
                            <button
                                type="button"
                                aria-expanded={!!expanded}
                                aria-controls={regionId}
                                onClick={onToggle}
                                className="tw-py-0.5 tw-px-0 tw-border-0 tw-bg-transparent tw-text-xs tw-font-medium tw-text-blue hover:tw-underline"
                            >
                                {actionLabel}
                            </button>
                        )}
                    </div>
                )}
            </div>
            {expanded && children && (
                <div id={regionId} className="tw-overflow-x-auto">
                    {children}
                </div>
            )}
        </div>
    );
}
